import { type ReactNode } from 'react';

import { Flex, Text } from '@spotify-internal/encore-web';
import { type IdentityRefFragment } from '@spotify/confidence-graphql';

import { identityKind } from '../../utils';
import { IdentityAvatar } from '../IdentityAvatar';

import styles from './IdentityInline.module.css';

export type IdentityInlineProps = {
  identityRef: IdentityRefFragment;
  children?: ReactNode;
};

export const IdentityInline = ({
  identityRef,
  children,
}: IdentityInlineProps) => {
  const isUser = identityKind(identityRef.name) === 'user';

  return (
    <Flex
      alignItems="center"
      gap="tighter-4"
      className={styles.root}
      {...(isUser ? { 'data-csr-mask': true } : {})}
    >
      <IdentityAvatar
        className={styles.avatar}
        size="var(--encore-graphic-size-decorative-smaller)"
        identityRef={identityRef}
      />
      <Text as="span" variant="bodySmall" lineClamp={1} textWrap="nowrap">
        {children ?? identityRef.displayName}
      </Text>
    </Flex>
  );
};
